import VideoTitle from './component.jsx'
export default VideoTitle
